import $ from 'jquery';
import _ from 'underscore';
import Bb from 'backbone';

/** A menu linked to multiple contacts.
 *
 */
var Menu = Bb.Model.extend({
  initialize() {
    const weeks = {};
    const self = this;

    _.each(this.get('rows'), function (row) {
      if (!weeks[row.week]) {
        const cols = [];

        _.each(row.cells, function (cell) {
          if (!_.findWhere(cols, { id: cell.column_id })) {
            cols.push(
              new Bb.Model(
                _.extend(
                  _.findWhere(self.get('columns'), { id: cell.column_id }),
                  {
                    key: cols.length + 1
                  }
                )
              )
            );
          }
        });

        weeks[row.week] = new Bb.Model({
          content: new Bb.Collection(),
          columns: new Bb.Collection(cols),
          week: row.week
        });
      }

      _.each(row.cells, function (cell) {
        const columns = weeks[row.week].get('columns');
        const column = columns.get(cell.column_id);
        if (column) {
          cell.column_key = column.get('key');
        }
      });
      row.cells = new Bb.Collection(row.cells);

      weeks[row.week].get('content').push(row);
    });

    this.set('collection', new Bb.Collection(_.values(weeks)));
  },

  sync() {
    var out = {
      description: this.get('description'),
      id: this.get('id'),
      rows: [],
      name: this.get('name'),
      columns: []
    };

    this.get('collection').each(function (week) {
      var weekNo = week.get('week');

      week.get('columns').each(function (col) {
        out.columns.push({
          key: weekNo * 100 + col.get('key'),
          description: col.get('description'),
          id: col.get('id'),
          week: weekNo,
          order: col.get('order')
        });
      });

      week.get('content').each(function (row) {
        const rowData = row.pick('colour', 'id', 'name', 'order');
        rowData.cells = [];
        rowData.week = weekNo;

        row.get('cells').each(function (cell) {
          rowData.cells.push({
            id: cell.id,
            description: cell.get('description'),
            column_key: weekNo * 100 + cell.get('column_key')
          });
        });
        out.rows.push(rowData);
      });
    });

    out.contacts = this.get('contacts');

    $.post(this.get('url'), JSON.stringify(out), rsp => {
      this.trigger('saved');

      if (!this.get('id')) {
        window.history.pushState(
          null,
          null,
          `/mealpicker/menus/${rsp.menu_id}`
        );
      }
    }).fail(() => {
      this.trigger('save:fail');
    });
  }
});

module.exports = Menu;



// WEBPACK FOOTER //
// ./menupicker/models/menu.js